import React, { useEffect, useState } from "react";
import EmployeeMenu from "./component/EmployeeMenu";
import { Color } from "../report/visitConstant/Color";
import ManageEmployee from "./component/ManageEmployee";
import Attendance from "./component/Attendance";

import ShiftDepartment from "./component/ShiftDepartment";
import GenerateReport from "./component/GenerateReport";
import AddHospital from "../report/AddHospital&Branch/AddHospital";
import AddHospitalBranch from "../report/AddHospital&Branch/AddHospitalBranch";
import DrSignUp from "../signup/DrSignUp";
import AddHospitalDoctor from "../report/AddHospital&Branch/AddHospitalDoctor";
import HospitalRegistration from "../report/AddHospital&Branch/Screens/HospitalRegistration";
import BranchRegistration from "../report/AddHospital&Branch/Screens/BranchRegistration";
import DoctorRegistration from "../report/AddHospital&Branch/Screens/DoctorRegistration";
import BranchToDrRag from "../report/AddHospital&Branch/Screens/BranchToDrRag";
import { USER_INFO } from "../Constant";

const Employee = () => {
  const [activeIdx, setActiveIdx] = useState(() => {
    const savedActiveIdx = sessionStorage.getItem("savedActiveIdx");
    return savedActiveIdx ? JSON.parse(savedActiveIdx) : 0;
  });
  const handleSideBar = (clickedCatId) => {
    setActiveIdx(clickedCatId);
  };

  const USERINFO = JSON.parse(localStorage.getItem(USER_INFO));

  const hospitalId = USERINFO.hospitalId;
  const BaranchId = USERINFO.branchId;
  const Role = USERINFO.role;

  //console.log(hospitalId ,BaranchId ,Role)

  return (
    <div style={{ paddingTop: 100 }} className="min-vh-100 ">
      <div className="d-lg-flex">
        <div className="bg-white ">
          <EmployeeMenu
            handleSideBar={handleSideBar}
            hospitalId={hospitalId}
            BaranchId={BaranchId}
            Role={Role}
          />
        </div>
        <div style={{ width: "100%", backgroundColor: Color.background }}>
          {activeIdx === 0 ? (
            <ManageEmployee
              hospitalId={hospitalId}
              BaranchId={BaranchId}
              Role={Role}
            />
          ) 
          : activeIdx === 1 ? (
            <Attendance
              hospitalId={hospitalId}
              BaranchId={BaranchId}
              Role={Role}
            />
          ) : activeIdx === 2 ? (
            <GenerateReport
              hospitalId={hospitalId}
              BaranchId={BaranchId}
              Role={Role}
            />
          ) 
          : activeIdx === 3 ? (
            <ShiftDepartment
              hospitalId={hospitalId}
              BaranchId={BaranchId}
              Role={Role}
            />
          ) : activeIdx === 4 ? (
            <HospitalRegistration
              hospitalId={hospitalId}
              BaranchId={BaranchId}
              Role={Role}
            />
          ) : activeIdx === 5 ? (
            <BranchRegistration
              hospitalId={hospitalId}
              BaranchId={BaranchId}
              Role={Role}
            />
          ) : activeIdx === 6 ? (
            <DoctorRegistration
              hospitalId={hospitalId}
              BaranchId={BaranchId}
              Role={Role}
            />
          ) : activeIdx === 7 ? (
            <BranchToDrRag
              hospitalId={hospitalId}
              BaranchId={BaranchId}
              Role={Role}
            />
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default Employee;
